import type { AllStatuses } from '@library/types/status';
import { StatusIndicator } from '@library/components/StatusIndicator';
import type { TradeHistoryAuditedChanges } from '@library/types/trading';
import arrowRight from '@library/assets/images/icons/arrow-right.svg';
import { formatDate } from '@library/component-utils/dateTime';
import { removeUnderscore } from '@bo-utils/common';

export interface TradeHistoryRowProps {
  source: string;
  comment: string;
  auditedChanges: TradeHistoryAuditedChanges;
  timestamp: string;
}

export const TradeHistoryRow = ({
  source,
  comment,
  auditedChanges,
  timestamp
}: TradeHistoryRowProps) => {
  const renderAuditedChanges = () => {
    return Object.keys(auditedChanges).map((key) => {
      const isStatus = key === 'status';
      let displayValueOne =
        auditedChanges[key as keyof TradeHistoryAuditedChanges]?.[0];

      let displayValueTwo =
        auditedChanges[key as keyof TradeHistoryAuditedChanges]?.[1];

      if (key === 'probability_of_more') {
        displayValueOne = Number(displayValueOne).toFixed(4);
        displayValueTwo = Number(displayValueTwo).toFixed(4);
      }

      if (key.includes('time')) {
        displayValueOne = formatDate({
          date: String(displayValueOne)
        });
        displayValueTwo = formatDate({
          date: String(displayValueTwo)
        });
      }
      return (
        <div key={`audited-changes-${key}`}>
          <div className="text-soClean-130 font-semibold capitalize">
            {removeUnderscore(key)}
          </div>

          <div className="flex items-center">
            {isStatus && auditedChanges[key] && (
              <StatusIndicator
                className="rounded-md pr-2"
                status={displayValueOne as AllStatuses}
              />
            )}
            <div className="text-soClean-130 capitalize">
              {removeUnderscore(String(displayValueOne))}
            </div>
            <img src={arrowRight} alt="-" className="p-2" />
            {isStatus && auditedChanges[key] && (
              <StatusIndicator
                className="rounded-md pr-2"
                status={displayValueTwo as AllStatuses}
              />
            )}
            <div className="text-soClean-130 capitalize">
              {removeUnderscore(String(displayValueTwo))}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="text-soClean-130 flex w-full py-4 text-xs font-thin">
      <div className="w-1/6 break-words px-2">
        {source?.replace('@', '\n@')}
      </div>
      <div className="w-2/6 px-2">{comment}</div>
      <div className="w-2/6 px-2">{renderAuditedChanges()}</div>
      <div className="w-1/6 px-2">{formatDate({ date: timestamp })}</div>
    </div>
  );
};
